import { CommonResponse } from 'shared/types/Api'
import { PaginationResponse } from 'shared/types/Common'

import { globalAPI } from 'shared/config/redux/api/global'
import { GET_TABLE_DATA } from 'shared/config/redux/constants/tags'

import { TableDataRequest } from '../types'

export const tableApi = globalAPI.injectEndpoints({
  endpoints: (build) => ({
    getTableData: build.query<
      CommonResponse<PaginationResponse<any>>,
      TableDataRequest
    >({
      query: (data) => ({
        url: data.url,
        params: data.params,
      }),
      providesTags: [GET_TABLE_DATA],
    }),
  }),
})

export const { useGetTableDataQuery } = tableApi
